import React, { FunctionComponent, useEffect, useState } from 'react';
import { Presentation } from './presentation';
import { useAdjustableDays } from '../../../hooks/useAdjustableDays';

type Props = {
  className: string;
  isNecessary: boolean;
  label: string;
  annotation?: string;
  name: string;
  onChanged: (name: string, value: string) => void;
};

export const Component: FunctionComponent<Props> = ({
  className,
  isNecessary,
  label,
  annotation,
  name,
  onChanged,
}) => {
  const [year, setYear] = useState('西暦');
  const [month, setMonth] = useState('月');
  const [day, setDay] = useState('日');

   const { dayOptions, correctedDay } = useAdjustableDays({ year, month, day });

  // 年・月が変更された結果、現在の `day` が存在しない日になったら補正する
  useEffect(() => {
    if (day !== correctedDay) {
      setDay(correctedDay);
      onChanged('day', correctedDay);
    }
  }, [correctedDay]);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    if (name === 'year') setYear(value);
    if (name === 'month') setMonth(value);
    if (name === 'day') setDay(value);
    onChanged(name, value);
  };

  const generateYearList = (): (number | string)[] => {
    const currentYear = new Date().getFullYear();
    const olderYears = Array.from({ length: 2000 - (currentYear - 90) }, (_, i) => currentYear - 90 + i);
    const recentYears = Array.from({ length: currentYear - 10 - 2000 + 1 }, (_, i) => 2000 + i);
    return [...olderYears, '西暦', ...recentYears];
  };

  return (
    <Presentation
      className={className}
      isNecessary={isNecessary}
      label={label}
      annotation={annotation}
      name={name}
      year={year}
      month={month}
      day={day}
      yearList={generateYearList()}
      dayList={dayOptions}
      handleChange={handleChange}
    />
  );
};
